import React from "react";
import s from "../labReportPdf.module.scss";

const FnacReportPdf = ({ profile, PageBaseLayout, PageFooter }) => {
  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />

      <div className={s.testCategoryHeader}>
        {profile?.profileName?.toUpperCase()}
      </div>

      <table className={s.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "45%" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="4" style={{ padding: "10px 15px" }}>
              <div
                className={s.fnacDescriptionContainer}
                style={{
                  lineHeight: "2",
                  fontSize: "14px",
                }}
                dangerouslySetInnerHTML={{
                  __html: profile?.fnacDescription || "",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <PageFooter />
    </div>
  );
};

export default FnacReportPdf;
